import gql from 'graphql-tag'

export const CREATE_ORDER = gql`
  mutation createOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      order {
        id
        name
        transferredAt
        paidAmount
        slug
      }
      errors
    }
  }
`

export const CANCEL_ORDER = gql`
  mutation cancelOrder($input: CancelOrderInput!) {
    cancelOrder(input: $input) {
      orders {
        id
      }
      errors
    }
  }
  `
export const PAY_ORDER = gql`
  mutation ($input: PayOrderInput!) {
    payOrder(input: $input) {
      order {
        id
        allStatus
        currentStateForm
        paymentAccepted
      }
      errors
    }
  }
`

export const ACCEPT_PAY_ORDER = gql`
  mutation ($input: AcceptRejectPaymentOrderInput!) {
    acceptRejectPaymentOrder(input: $input) {
      orders {
        id
        allStatus
        currentStateForm
        paymentAccepted
      }
      errors
    }
  }
`

export const CONFIRM_SHIP_ORDER = gql`
  mutation ($input: ConfirmShipOrderInput!) {
    confirmShipOrder(input: $input) {
      order {
        id
        allStatus
        currentStateForm
      }
      errors
    }
  }
`

export const MARK_PRINT_ORDER = gql`
  mutation ($input: MarkPrintOrderInput!) {
    markPrintOrder(input: $input) {
      orders {
        id
        printed
      }
      errors
    }
  }
`

export const CLOSE_ORDER = gql`
  mutation ($input: CloseOrderInput!) {
    closeOrder(input: $input) {
      order {
        id
        allStatus
        currentStateForm
      }
      errors
    }
  }
`

export const CONFIRM_PACK_ORDER = gql`
  mutation ($input: ConfirmPackOrderInput!) {
    confirmPackOrder(input: $input) {
      orders {
        id
        allStatus
        currentStateForm
      }
      errors
    }
  }
`

export const UNDO_CLOSE_ORDER = gql`
  mutation ($input: UndoCloseOrderInput!) {
    undoCloseOrder(input: $input) {
      orders {
        id
        allStatus
        currentStateForm
      }
      errors
    }
  }
`

export const UPDATE_ORDER = gql`
  mutation ($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      order {
        id
        allStatus
        orderBank
        currentStateForm
        resellerId
        holding
        printed
      }
      errors
    }
  }
`

export const NOTIFY_EXPIRED_ORDER = gql`
  mutation ($input: NotifyExpiredOrderInput!) {
    notifyExpiredOrder(input: $input) {
      order {
        id
      }
      errors
    }
  }
`

export const MERGE_ORDER = gql`
  mutation ($input: MergeOrderInput!) {
    mergeOrder(input: $input) {
      order {
        id
      }
      errors
    }
  }
`

export default {
  CREATE_ORDER,
  CANCEL_ORDER,
  PAY_ORDER,
  ACCEPT_PAY_ORDER,
  CONFIRM_SHIP_ORDER,
  MARK_PRINT_ORDER,
  CLOSE_ORDER,
  CONFIRM_PACK_ORDER,
  UNDO_CLOSE_ORDER,
  UPDATE_ORDER,
  NOTIFY_EXPIRED_ORDER,
  MERGE_ORDER
}
